<template>
    <div class="logo">
        <img src="../../assets/images/Feedback/chief.jpg" alt="Đầu bếp">
    </div>
</template>

<style scoped>
.logo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 32px 24px;
}
.logo img {
    width: 100%;
}
@media screen and (max-width: 992px) {
    .logo {
        display: none;
    }
}
</style>